import "./Services.css";
import { ServiceCard } from "./ServiceCard";
import { useNavigate } from "react-router-dom";

export const Services = () => {
  const navigate = useNavigate();

  const serviceInfoRow1 = [
    
  ];
  const serviceInfoRow2 = [
    {
      header: "Tour Packages",
      info: "Best overall travel package deals on discounted price",
      icon: "fas fa-rupee-sign",
      onClick: () => navigate("/packages"), 
    },
    
    {
      header: "Hotels",
      info: "Best Accessible sites, clean and secure Hotels for accomodation",
      icon: "fas fa-hotel",
      onClick: () => navigate("/hotels"), 
    },
    {
      header: "Food And Drinks",
      info: "Delicious Foods with lots of options ",
      icon: "fas fa-utensils",
    },

    {
      header: "Safe Travels",
      info: "Pickup and drop facility available, your safety our priority",
      icon: "fas fa-clinic-medical",
    },
  ];

  return (
    <>
      <div className="container4">
        <section className="service" id="services">
          <h1>Have a look at our services!</h1>
          <div className="row2">
            {serviceInfoRow1.map((element, index) => {
              return (
                <ServiceCard
                key={index} // Adding unique key prop
                  header={element.header}
                  info={element.info}
                  icon={element.icon}
                />
              );
            })}
          </div>
          <div className="row1">
            {serviceInfoRow2.map((element, index) => {
              return (
                <ServiceCard
                key={index} // Adding unique key prop
                  header={element.header}
                  info={element.info}
                  icon={element.icon}
                  onClick={element.onClick} 
                />
              );
            })}
          </div>
        </section>
      </div>
    </>
  );
};
